import Avatar from "../Avatar";
import { useChatWidgetContext } from "../../../providers/ChatWidgetProvider";
import Message from "../../chat/message";
import { useEffect, useRef } from "react";
import icon from "../../../assets/images/elems/logo-tk-chat-user.svg";

const ChatWidgetConversation = () => {
  const { conversation } = useChatWidgetContext();
  const messageEndRef = useRef(null);
  useEffect(() => {
    messageEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [conversation.messages]);

  return (
    <>
      <div className="text-center mt-10">
        <Avatar
          src={icon}
          size="3xl"
          className="mx-auto p-2 rounded-circle white-chat-bg"
        />
        <p className="text-center text-body-emphasis mb-0 mt-2">
          Я помощник по обслуживанию абонентов
          <br />
          Телекарты и Орион Экспресс
        </p>
      </div>

      {conversation.messages.length > 0 && (
        <>
          <br className="my-2" />
          <div className="d-flex flex-column gap-2">
            {conversation.messages.map((message) => (
              <Message
                message={message}
                user={conversation.user}
                key={message.id}
                showActions={false}
              />
            ))}
            <span ref={messageEndRef} />
          </div>
        </>
      )}
    </>
  );
};

export default ChatWidgetConversation;
